import { defHttp } from '/@/request';
import { Result, ErrorMessageMode } from '/#/axios';
import { getAppEnvConfig } from '/@/utils/env';
import axios from 'axios';

const { VITE_GLOB_WEBSOCKET_URL, VITE_GLOB_WX_URL, VITE_GLOB_API_URL } =
  getAppEnvConfig();

import {
  SendVcodeApihParamsModel,
  WhiteSendVcodehParamsModel,
  DicthParamsModel,
  DictListhResultModel,
  FuzzySearchParamsModel,
  SearchKefuResultModel,
  SearchOrgParamsModel,
  SearchOrgResultModel,
  SearchUserParamsModel,
  SearchUserResultModel,
} from './model';
enum Api {
  sendVcode = 'base/sms/v1/send/vCode', // 发送验证码接口
  whiteSendVcode = 'base/sms/v1/send/vCode/white', // 发送验证码接口
  websocketUrl = 'worksheet/websocket/end/point', // 推送工单数量websocket地址
  dictList = 'base/dict/v1/list', // 字典查询
  kefuList = 'tenant/user/v1/search/kefu', // 客服模糊查询列表
  orgFuzzySearch = 'tenant/org/v1/search', // 组织模糊查询
  userFuzzySearch = 'tenant/user/v1/search', // 用户模糊查询
  DictList = 'base/dict/item/v1/list', // 字段查询...
  getWarning = 'base/notice/v1/list',
  readWarning = 'base/notice/v1/read',
  taskList = 'base/task/v1/page', //任务式下载列表
  saveTask = 'base/task/v1/save', //创建任务式下载任务
  deleteTask = 'base/task/v1/delete', //删除任务式下载任务
}
export const imgPrefix = 'https://store.lerke.cn/';
export const WebsocketUrlApi = `${VITE_GLOB_WEBSOCKET_URL}worksheet/websocket/end/point`;
export const OfficialAccountApi =
  VITE_GLOB_WX_URL + '/web/qrcode/weixin/qrcode/ticket'; // 微信公众号

export function getOfficialAccountApi(data) {
  return axios.get(OfficialAccountApi, {
    params: data,
  });
}

// export function getOfficialAccountApi(data) {
//   return defHttp.get<Result>({
//     url: VITE_GLOB_WX_URL + '/' + Api.officialAccount,
//     params: data,
//   });
// }
export function sendVcodeApi(
  data: SendVcodeApihParamsModel,
  mode?: ErrorMessageMode
) {
  return defHttp.post<Result>({
    url: Api.sendVcode,
    data,
  });
}

export function whiteSendVcodeApi(data: WhiteSendVcodehParamsModel) {
  return defHttp.post<Result>({
    url: Api.whiteSendVcode,
    data,
  });
}
export function dictListApi(data: DicthParamsModel) {
  return defHttp.post<Result<DictListhResultModel>>({
    url: Api.dictList,
    data,
  });
}

export function kefuListApi(data: FuzzySearchParamsModel) {
  return defHttp.post<Result<SearchKefuResultModel>>({
    url: Api.kefuList,
    data,
  });
}
// 组织模糊查询
export function orgFuzzySearchApi(data: SearchOrgParamsModel) {
  return defHttp.post<Result<SearchOrgResultModel>>({
    url: Api.orgFuzzySearch,
    data,
  });
}
// 用户模糊查询
export function userFuzzySearchApi(data: SearchUserParamsModel) {
  return defHttp.post<Result<SearchUserResultModel>>({
    url: Api.userFuzzySearch,
    data,
  });
}

export function getDictListApi(data: { codes?: string[] }) {
  return defHttp.post<Result>({
    url: Api.DictList,
    data,
  });
}

export function getWarningApi() {
  return defHttp.post<Result>({
    url: Api.getWarning,
  });
}
export function readWarningApi(data: any) {
  return defHttp.post<Result>({
    url: Api.readWarning,
    data,
  });
}

// 任务式下载列表
export function taskListApi(data: { page?: Number; pageSize?: Number }) {
  return defHttp.post<Result>({
    url: Api.taskList,
    data,
  });
}
// 查询人工排班列表

//创建任务式下载任务
export function createTaskApi(data: { type?: String; params?: any }) {
  return defHttp.post<Result>({
    url: Api.saveTask,
    data,
  });
}

//删除任务式下载任务
export function deleteTaskApi(data: { pkId?: Number }) {
  return defHttp.post<Result>({
    url: Api.deleteTask,
    data,
  });
}
export const aliExcelUploadApi =
  VITE_GLOB_API_URL + 'goods/standard/ali/v1/upload';
// 导入值班人员
export const scheduleServiceImport =
  VITE_GLOB_API_URL + 'worksheet/rule/schedule/v1/serviceImport';
